// Quantity steppers on the product page.
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-qty]');
  if (!btn) return;
  const input = btn.parentElement.querySelector('input[name="quantity"]');
  if (!input) return;
  const next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.qty, 10));
  input.value = next;
});

// Product gallery thumbnails swap the main image.
document.addEventListener('click', (e) => {
  const thumb = e.target.closest('.pdp-thumb');
  if (!thumb) return;
  const main = document.getElementById('pdp-main');
  if (main && thumb.dataset.full) main.src = thumb.dataset.full;
});
